import {
    type MembershipProfileAnswerWithQuestion,
    type MembershipProfileMoneyGoalAnswer,
    type ProfileAnswer,
    QuestionKey,
    transformEnumToDisplay,
} from '@fruitful/member-profile';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { BodyMediumRegular, H6Emphasized, YStack } from 'smoothie';

import { findMembershipProfileAnswerByQuestionKey } from '../utils/memberProfileUtils';

interface MembershipInfoProps {
    membershipProfileAnswers: Array<
        MembershipProfileAnswerWithQuestion<ProfileAnswer>
    >;
}

export const MembershipFinancialGoalsTable = ({
    membershipProfileAnswers,
}: MembershipInfoProps) => {
    // Prefer MONEY_GOALS_ONBOARDING_V2 if it exists, otherwise fall back to MONEY_GOALS
    const moneyGoalsV2 = findMembershipProfileAnswerByQuestionKey<
        ProfileAnswer,
        MembershipProfileMoneyGoalAnswer[]
    >(membershipProfileAnswers, QuestionKey.MONEY_GOALS_ONBOARDING_V2);

    const moneyGoals =
        moneyGoalsV2 ??
        findMembershipProfileAnswerByQuestionKey<
            ProfileAnswer,
            MembershipProfileMoneyGoalAnswer[]
        >(membershipProfileAnswers, QuestionKey.MONEY_GOALS);

    return (
        <YStack gap={12}>
            <H6Emphasized>Financial Goals</H6Emphasized>
            {moneyGoals == null ? (
                <BodyMediumRegular>
                    No financial goals data found.
                </BodyMediumRegular>
            ) : (
                <DataTable
                    value={moneyGoals.answer}
                    size="small"
                    tableStyle={{ width: '100%', fontSize: 13 }}
                    scrollable
                >
                    <Column
                        field="answer"
                        header="Goal"
                        body={({ answer }: MembershipProfileMoneyGoalAnswer) =>
                            answer != null ? transformEnumToDisplay(answer) : ''
                        }
                    />
                    <Column
                        field="additionalInformation"
                        header="Additional info"
                    />
                </DataTable>
            )}
        </YStack>
    );
};
